import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MobileDetect from 'mobile-detect';

export default class DeviceDependentElement extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    mobile: PropTypes.bool,
    desktop: PropTypes.bool
  };

  static defaultProps = {
    mobile: false,
    desktop: false,
  };

  constructor(props, context) {
    super(props, context);
    this.isMobile = new MobileDetect(window.navigator.userAgent).mobile();
  }

  render() {
    if ((this.props.mobile && !this.isMobile) || (this.props.desktop && this.isMobile)) {
      return null;
    }
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/DeviceDependentElement.jsx